import { render, staticRenderFns } from "./DocumentsLibrary.handler.vue?vue&type=template&id=4a57fb96&"
import script from "./DocumentsLibrary.handler.vue?vue&type=script&lang=ts&"
export * from "./DocumentsLibrary.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports